import script from "./ConsumerCartView.vue?vue&type=script&setup=true&lang=js"
export * from "./ConsumerCartView.vue?vue&type=script&setup=true&lang=js"

import "./ConsumerCartView.vue?vue&type=style&index=0&id=1ff7de8c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ff7de8c"]])

export default __exports__